import React, { useEffect } from 'react';
import styles from '../../styles/cards.module.css';
import { padronctc } from '../../json/padronctc';

const PadronCTC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='transparencia_title'>
                        <h3 className={ styles.title }>
                            Padrón de Beneficiarios del Programa Construye Tu Camino por año
                        </h3>
                        <hr className='hr-gob'></hr>
                    </div>
                </div>
                {
                    padronctc.map((item, index)=>(
                        <div key={ index } className='col-md-4 col-sm-6 col-12'>
                            <div className={ styles.container }>
                                <h5 className={ styles.name }>
                                    Año { item.year }.
                                </h5>
                                <hr></hr>
                                <a className={ styles.link } href={ item.url } target='_blank' rel='noopener noreferrer'>
                                    <div className={ styles.item }>
                                        <p className={ styles.textLink} >
                                            Beneficiarios del programa.
                                        </p>
                                        <i className={`icon-file-pdf ${ styles.iconLink }`} aria-hidden='true'></i>
                                    </div>
                                </a>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default PadronCTC;